<div class="training-card" (click)="openTraining()">
  <div class="training-card-image">
    <img
      appTrainingImageFallback
      [src]="training.imageFile?.fileUrl"
      alt="training-image"
    />
  </div>
  <div class="training-content">
    <div class="training-title">
      {{ training.name }}
    </div>
    <div class="training-description">
      {{ training.description }}
    </div>
    <div class="training-badge-container">
      <div class="training-date">
        <div class="training-badge">
          <div
            class="training-badge-container"
            *ngIf="training.dates && training.dates[0]"
          >
            <div class="training-badge-content">
              <i class="dx-icon dx-svg-icon" [innerHTML]="getCalendarIcon()"></i>
              {{
                training.dates[0].start
                  | date : "dd LLL yyyy" : "" : translateService.currentLang
              }}
            </div>
        </div>
        </div>
      </div>
      <div
        class="training-location"
        *ngIf="training.location"
      >
      <div class="training-badge">
        <div class="training-badge-container">
          <div class="training-badge-content">
            <i
              class="dx-icon dx-svg-icon"
              [innerHTML]="getLocationIcon()"
            ></i>
            {{ getTrainingLocation(training.location) }}
          </div>
        </div>
      </div>
      </div>
      <div class="training-bottom">
        <div class="training-type">
          <div class="training-badge">
            <div class="training-badge-container">
              <div class="training-badge-content">
                <i
                  class="dx-icon dx-svg-icon"
                  [innerHTML]="getTypeIcon()"
                ></i>
                {{ getTrainingTypeLabel(training.trainingType) }}
              </div>
            </div>
          </div>
        </div>
        <div class="training-category">
          <div class="training-badge">
            <div 
              class="training-badge-container"  
              *ngIf="training.trainingCategories.length"
            >
              <div class="training-badge-content">
                <i
                  class="dx-icon dx-svg-icon"
                  [innerHTML]="getCategoryIcon()"
                ></i>
                <span class="category-badge">
                  {{ getTrainingCategoriesLabel() }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="training-action">
    <dx-button
      [text]="'MY-TRAININGS.OVERVIEW.TO-EVENT' | translate"
      type="normal"
      class="open-training-button"
      stylingMode="contained"
      (onClick)="openTraining()"
    ></dx-button>
  </div>
</div>